export default {
  choose_subject: "Choisissez une matière",
  show_lesson: "Voir le cours",
  course: "Cours",
  lessonLink: "Lien",
  activityDone: "Activités faites",
  workToDo: "Travail à préparer",
  generalCourses: "Cours généraux",
  attachments: "Pièces jointes",
  attachment: "Pièce jointe",
  download: "Télécharger",
  "Taught subject": "Matière enseignée",
  lesson_info:
    "Ce menu permet de paramétrer des matières en lien avec différents modules : calendrier, compétences, bulletin de notes",
};
